const SDK_VERSION = '7.113.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
